<template>
  <div id="invoice-preview-modal"
       class="modal fade"
       tabindex="-1"
       role="dialog"
       aria-labelledby="invoice-preview-modal-label"
       aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header custom-modal-header">
          <div class="custom-modal-header-start">
            <h4 class="modal-title custom-modal-header-start-title">
              Preview Invoice
            </h4>
          </div>
          <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div>
          <InvoiceHeader
            :invoice-number="builtInvoice.merchant_invoice_number"
            :invoice-date="builtInvoice.date"
            :invoice-due-date="builtInvoice.due_date"
            :invoice-subject="builtInvoice.subject"
            :invoice-amount="builtInvoice.total"
            invoice-status="draft"
            pill-color-class="status-grey"
            :currency-iso-code="builtInvoice.currency_iso_code"
            :customer-name="builtInvoice.customer_info['customer_display_name']" />
          <FormCard
            v-model="builtInvoice"
            :show-buttons="false"
            :no-padding="true">
            <CardForm
              :resource="builtInvoice"
              :header-no-wrap="false"
              :show-title="false"
              resource-name="invoice"
              :no-border="true"
              :no-padding="true"
              class="mb-0">
              <InvoiceContent
                :invoice="builtInvoice"
                pill-color-class="status-grey" />
            </CardForm>
          </FormCard>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import InvoiceHeader from "./InvoiceShow/InvoiceHeader.vue";
import FormCard from "../../../shared/components/UI/FormCard.vue";
import CardForm from "../../../shared/components/UI/CardForm.vue";
import InvoiceContent from "./InvoiceShow/InvoiceContent.vue";

export default {
  name: "InvoicePreviewModal",

  components: {
    InvoiceHeader,
    InvoiceContent,
    FormCard,
    CardForm
  },

  props: {
    merchantInvoiceNumber: { type: String },
    invoiceDate: { type: [Date, String] },
    invoice: { type: Object },
    dueDate: { type: [Date, String] },
    customerTotal: { type: Number },
    invoiceSubtotal: { type: Number },
    vatAmount: { type: Number },
    selectedTax: { type: Object },
    invoiceAttachment: { type: Array },
    customer: { type: Object },
    invoiceCurrency: { type: Object },
    documentTitle: { type: String },
    merchant: { type: Object },
    displayedComponents: { type: Object }
  },

  data () {
    return {
      total: null,
      subtotal: null
    };
  },

  computed: {
    ...mapGetters("lineItems", {
      discountValue: "discountAmount",
      lineItemsSubtotal: "subtotalAmount",
      lineItemsTotalAmount: "totalAmount",
      lineItems: "nonRemovedLineItems"
    }),

    customerInfo () {
      if (this.customer) {
        return {
          customer_display_name: this.customer.display_name,
          customer_email: this.customer.email,
          customer_mobile_number: this.customer.mobile_number,
          customer_billing_address: this.customer.billing_address,
          customer_shipping_address: this.customer.shipping_address
        };
      } else {
        return {
          customer_display_name: "",
          customer_email: ""
        };
      }
    },

    merchantInfo () {
      return {
        address: this.merchant.address,
        city: this.merchant.city,
        company_logo_url: this.merchant.logo.company_logo["url"],
        country_name: this.merchant.country.name,
        email: this.merchant.email,
        legal_name: this.merchant.legal_name
      };
    },

    builtInvoice () {
      return {
        merchant_invoice_number: this.merchantInvoiceNumber,
        date: this.invoiceDate,
        subject: this.invoice.subject,
        due_date: this.dueDate,
        currency: this.invoiceCurrency,
        po_reference: this.invoice.po_reference,
        currency_iso_code: this.invoiceCurrency.iso_code,
        total: this.total,
        line_items: this.lineItems,
        description: { files: this.invoiceAttachment },
        notes: this.displayedComponents.notes ? this.invoice.notes : null,
        barcode_url: "/qrcode.png",
        selectedTax: this.selectedTax,
        vatAmount: this.vatAmount,
        status: "draft",
        document_title: this.documentTitle,
        conditions: this.displayedComponents.conditions ? this.invoice.conditions : null,
        invoice_subtotal: this.subtotal,
        discount: this.discountValue ? { amount: this.discountValue } : null,
        text_description: this.displayedComponents.description ? this.invoice.text_description : null,
        customer_info: this.customerInfo,
        merchant_info: this.merchantInfo
      };
    }
  },

  watch: {
    "lineItemsSubtotal": function (newVal) {
      this.subtotal = newVal;
    },

    "lineItemsTotalAmount": function (newVal) {
      this.total = newVal;
    }
  },

  created () {
    this.subtotal = this.lineItemsSubtotal;
    this.total = this.lineItemsTotalAmount;
  }
};
</script>
